import { validators, validateRule, buildRules } from "./rules";
import { uiManager } from "./uiManager";

export const validationCore = {
  validateField: (value, element, rules) => {
    return rules
      .map(validateRule(value, element))
      .filter((result) => !result.isValid)
      .map((result) => result.message);
  },

  validateData: (rules) => (data) => {
    const errors = Object.entries(rules).reduce((acc, [fieldName, fieldRules]) => {
      const fieldData = data[fieldName];
      const value = fieldData?.value ?? fieldData;
      const element = fieldData?.element;
      const fieldErrors = validationCore.validateField(value, element, fieldRules);

      return fieldErrors.length ? { ...acc, [fieldName]: fieldErrors } : acc;
    }, {});

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  },
};

export const createValidator = (form) => ({
  validateForm: () => {
    const rules = buildRules(form);
    const formData = Object.entries(rules).reduce(
      (acc, [fieldName]) => ({
        ...acc,
        [fieldName]: {
          value: form.elements[fieldName]?.value,
          element: form.elements[fieldName],
        },
      }),
      {},
    );

    const result = validationCore.validateData(rules)(formData);
    uiManager.updateFormUI(form, result.errors);
    return result;
  },

  validateField: (fieldName) => {
    const rules = buildRules(form);
    const element = form.elements[fieldName];

    if (!element || !rules[fieldName]) {
      return { isValid: true, errors: {} };
    }

    const result = validationCore.validateData({ [fieldName]: rules[fieldName] })({
      [fieldName]: { value: element.value, element },
    });

    uiManager.updateFormUI(form, result.errors);
    return result;
  },

  addValidator: (name, validatorFn, defaultMessage) => {
    validators[name] = (value, element, ...params) => ({
      isValid: validatorFn(value, element, ...params),
      defaultMessage,
    });
  },

  addFieldError: (field, message) => uiManager.addFieldError(field, message),

  clearErrors: () => uiManager.clearFormErrors(form),
});
